export const environment = {
  production: true,
  baseApiUrl: '/api/latest',
  instrumentationKey: '3e43f695-3051-4597-a6f5-cefb8efba2b6',
  raygun: {
    apiKey: 'F5RK2XfiBWBzf9BBYkNNqg'
  },
  supportedLangs: [
    'en', 'nl', 'de'
  ]
};
